__turbopack_context__.v({
  "mobileDivider": "JUINAG_mobileDivider",
});
